import { useCallback } from 'react';
import { toast } from 'react-hot-toast';

import { useAuth } from 'src/hooks/use-auth';
import { useSocketEvent } from 'src/hooks/use-socket-event';
import { formatCurrency } from 'src/utils/format-currency';

const tipoLabels = {
  fideicomiso_flujos: 'Fideicomiso de Flujos',
  osce: 'OSCE',
  bienes_servicios: 'Bienes & Servicios',
  obras_impuestos: 'Obras por Impuestos',
  fondo_mivivienda: 'Fondo Mi Vivienda',
  contrato_mutuo: 'Contrato de Mutuo',
};

export const ConsolidacionNotificacion = () => {
  const { user } = useAuth();

  const handleConsolidada = useCallback(
    (data) => {
      if (!data || !user?.user_id || !data.user_ids?.includes(user.user_id)) return;
      const fechaInicio = data.fecha_inicio
        ? new Date(data.fecha_inicio).toLocaleDateString('es-PE')
        : '-';
      const fechaPago = data.fecha_pago
        ? new Date(data.fecha_pago).toLocaleDateString('es-PE')
        : '-';
      toast.success(
        `Tu inversión fue consolidada · ${tipoLabels[data.tipo_inversion] || 'Operación'} · ` +
          `${formatCurrency(data.monto_a_financiar, data.moneda || 'PEN')} · Tasa ${data.tasa}% ` +
          `· Plazo ${data.plazo_dias} días · Inicio: ${fechaInicio} · Fecha de pago: ${fechaPago}`,
        { duration: 10000, position: 'top-center' }
      );
    },
    [user]
  );

  useSocketEvent('operacion:consolidada', handleConsolidada, [handleConsolidada]);

  return null;
};